/** Mirrors backend CorporateCompanyType enum. */
export type CorporateCompanyType = 'SoleProprietorship' | 'LimitedOrAnonymous';

export const CORPORATE_COMPANY_TYPE_LABELS: Record<CorporateCompanyType, string> = {
  SoleProprietorship: 'Şahıs şirketi',
  LimitedOrAnonymous: 'Limited / Anonim şirket',
};
